import { render, staticRenderFns } from "./or_xld_report.vue?vue&type=template&id=90604e4a&scoped=true"
import script from "./or_xld_report.vue?vue&type=script&lang=js"
export * from "./or_xld_report.vue?vue&type=script&lang=js"
import style0 from "./or_xld_report.vue?vue&type=style&index=0&id=90604e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90604e4a",
  null
  
)

export default component.exports